import { useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';
import DesktopLayout from './desktop';
import MobileLayout from './mobile';
import { SnackbarProvider } from 'notistack';
import SidePanProvider from '@Providers/SidePanProvider';

const Layout: FC = () => {
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <>
            <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            />
            <SidePanProvider>
                {isSmUp ? <DesktopLayout /> : <MobileLayout />}
            </SidePanProvider>
        </>
    );
};

export default Layout;
